// // pages/_app.js
// import { Fragment, useEffect } from "react";
// import dynamic from "next/dynamic";
// import Head from "next/head";
// import Script from "next/script";
// import { useRouter } from "next/router";

// import "nprogress/nprogress.css";
// import "./global.css";

// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// import { appWithTranslation } from "next-i18next";
// import { LanguageProvider } from "../context/LanguageContext";
// import nextI18NextConfig from "../next-i18next.config";

// import RouteLoader from "../components/common/RouteLoader";
// import FontWrapper from "../components/common/FontWrapper";
// import { captureUTMParams } from "../utils/utm";
// import { ContactModalProvider } from "../context/ContactModalContext";

// // ---------------------------------------------------------------------
// // Dynamic imports: these render nothing on first paint (modals, floating
// // widgets), so loading them client-side after hydration keeps them out
// // of the critical initial-load path.
// // ---------------------------------------------------------------------
// const ContactFormModal = dynamic(
//   () => import("../components/contact/ContactFormModal"),
//   { ssr: false },
// );
// const FloatingContactWidget = dynamic(
//   () => import("../components/common/FloatingContactWidget"),
//   { ssr: false },
// );
// const FloatingIcon = dynamic(
//   () => import("../components/common/floating-icon"),
//   { ssr: false },
// );

// const GTM_ID = "GTM-MMNRM89";
// const CLARITY_ID = "ok3v52c1qw";
// const FB_PIXEL_ID = "521656605186429";

// function pushToDataLayer(payload) {
//   if (typeof window === "undefined") return;
//   window.dataLayer = window.dataLayer || [];
//   window.dataLayer.push(payload);
// }

// function MyApp({ Component, pageProps }) {
//   const router = useRouter();
//   const { locale } = router;
//   const rawPath = router.asPath.split("?")[0];
//   const normalizedPath = rawPath.replace(/^\/(en|ar)/, "");

//   useEffect(() => {
//     captureUTMParams();
//   }, []);

//   // GTM SPA navigation tracking
//   useEffect(() => {
//     const handleRouteChange = (url) => {
//       pushToDataLayer({
//         event: "virtual_pageview",
//         page_path: url,
//         page_location: window.location.href,
//       });
//     };

//     if (typeof window !== "undefined") handleRouteChange(router.asPath);

//     router.events.on("routeChangeComplete", handleRouteChange);
//     return () => router.events.off("routeChangeComplete", handleRouteChange);
//   }, [router]);

//   return (
//     <Fragment>
//       <Head>
//         <title>Prism Digital</title>
//         <meta
//           name="viewport"
//           content="minimum-scale=1, initial-scale=1, width=device-width"
//         />
//         <link rel="icon" href="/favicon.ico" />
//       </Head>

//       <Script id="gtm" strategy="afterInteractive">
//         {`
//           (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
//           new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
//           j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
//           'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
//           })(window,document,'script','dataLayer','${GTM_ID}');
//         `}
//       </Script>

//       {/* Clarity: lazy */}
//       <Script id="clarity" strategy="lazyOnload">
//         {`
//           (function(c,l,a,r,i,t,y){
//             c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
//             t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
//             y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
//           })(window, document, "clarity", "script", "${CLARITY_ID}");
//         `}
//       </Script>

//       {/* FB Pixel: lazy + delay */}
//       <Script id="fb-pixel" strategy="lazyOnload">
//         {`
//           setTimeout(function(){
//             !function(f,b,e,v,n,t,s)
//             {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
//             n.callMethod.apply(n,arguments):n.queue.push(arguments)};
//             if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
//             n.queue=[];t=b.createElement(e);t.async=!0;
//             t.src=v;s=b.getElementsByTagName(e)[0];
//             s.parentNode.insertBefore(t,s)}(window, document,'script',
//             'https://connect.facebook.net/en_US/fbevents.js');
//             fbq('init', '${FB_PIXEL_ID}');
//             fbq('track', 'PageView');
//           }, 2500);
//         `}
//       </Script>

//       <FontWrapper locale={locale}>
//         <LanguageProvider>
//           <ContactModalProvider>
//             <ToastContainer
//               position="top-right"
//               autoClose={5000}
//               rtl={locale === "ar"}
//               pauseOnFocusLoss={false}
//               pauseOnHover={false}
//               theme="light"
//             />
//             <RouteLoader />
//             <Component {...pageProps} />
//             <ContactFormModal />
//             <FloatingContactWidget />
//             <FloatingIcon />
//           </ContactModalProvider>
//         </LanguageProvider>
//       </FontWrapper>
//     </Fragment>
//   );
// }

// export default appWithTranslation(MyApp, nextI18NextConfig);

// pages/_app.js
import { Fragment, useEffect, useState } from "react";
import dynamic from "next/dynamic";
import Head from "next/head";
import { useRouter } from "next/router";

import "nprogress/nprogress.css";
import "./global.css";
import "react-toastify/dist/ReactToastify.css";

import { appWithTranslation } from "next-i18next";
import { LanguageProvider } from "../context/LanguageContext";
import nextI18NextConfig from "../next-i18next.config";

import RouteLoader from "../components/common/RouteLoader";
import FontWrapper from "../components/common/FontWrapper";
import { captureUTMParams } from "../utils/utm";
import { ContactModalProvider } from "../context/ContactModalContext";

// Client-only, not needed for first paint
const ToastContainer = dynamic(
  () => import("react-toastify").then((m) => m.ToastContainer),
  { ssr: false },
);
const ContactFormModal = dynamic(
  () => import("../components/contact/ContactFormModal"),
  { ssr: false },
);
const FloatingContactWidget = dynamic(
  () => import("../components/common/FloatingContactWidget"),
  { ssr: false },
);
const FloatingIcon = dynamic(
  () => import("../components/common/floating-icon"),
  { ssr: false },
);

const GTM_ID = "GTM-MMNRM89";
const CLARITY_ID = "ok3v52c1qw";
const FB_PIXEL_ID = "521656605186429";

function pushToDataLayer(payload) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

// ---------------------------------------------------------------------
// Third-party loaders (injected manually so we control timing)
// ---------------------------------------------------------------------
function injectScript(src) {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

function loadGTM() {
  if (window.__gtmLoaded) return;
  window.__gtmLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  injectScript(`https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`);
}

function loadClarity() {
  if (window.clarity) return;
  window.clarity = function () {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };
  injectScript(`https://www.clarity.ms/tag/${CLARITY_ID}`);
}

function loadFbPixel() {
  if (window.fbq) return;
  const n = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  });
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  injectScript("https://connect.facebook.net/en_US/fbevents.js");
  window.fbq("init", FB_PIXEL_ID);
  window.fbq("track", "PageView");
}

// Load on first user interaction, or after a fallback timeout.
// Scripts are staggered so they don't land as one long task.
function useDeferredThirdParties(fallbackMs = 4000) {
  useEffect(() => {
    const events = ["pointerdown", "keydown", "scroll", "touchstart"];
    const timers = [];
    let started = false;

    const start = () => {
      if (started) return;
      started = true;
      events.forEach((e) => window.removeEventListener(e, start));
      clearTimeout(fallbackTimer);

      loadGTM();
      timers.push(setTimeout(loadClarity, 1500));
      timers.push(setTimeout(loadFbPixel, 3000));
    };

    events.forEach((e) =>
      window.addEventListener(e, start, { passive: true, once: true }),
    );
    const fallbackTimer = setTimeout(start, fallbackMs);

    return () => {
      events.forEach((e) => window.removeEventListener(e, start));
      clearTimeout(fallbackTimer);
      timers.forEach(clearTimeout);
    };
  }, [fallbackMs]);
}

// Flip to true once the browser is idle (or after a timeout)
function useIdleMount(timeout = 2000) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const go = () => setReady(true);
    if ("requestIdleCallback" in window) {
      const id = window.requestIdleCallback(go, { timeout });
      return () => window.cancelIdleCallback(id);
    }
    const id = setTimeout(go, timeout);
    return () => clearTimeout(id);
  }, [timeout]);
  return ready;
}

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  const { locale } = router;

  const widgetsReady = useIdleMount(2000);
  useDeferredThirdParties(4000);

  useEffect(() => {
    captureUTMParams();
  }, []);

  // GTM SPA navigation tracking: subscribe once, not on every router change
  useEffect(() => {
    const handleRouteChange = (url) => {
      pushToDataLayer({
        event: "virtual_pageview",
        page_path: url,
        page_location: window.location.href,
      });
    };

    handleRouteChange(router.asPath); // initial load
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => router.events.off("routeChangeComplete", handleRouteChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <Head>
        <title>Prism Digital</title>
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <FontWrapper locale={locale}>
        <LanguageProvider>
          <ContactModalProvider>
            {widgetsReady && (
              <ToastContainer
                position="top-right"
                autoClose={5000}
                rtl={locale === "ar"}
                pauseOnFocusLoss={false}
                pauseOnHover={false}
                theme="light"
              />
            )}
            <RouteLoader />
            <Component {...pageProps} />
            {widgetsReady && (
              <>
                <ContactFormModal />
                <FloatingContactWidget />
                <FloatingIcon />
              </>
            )}
          </ContactModalProvider>
        </LanguageProvider>
      </FontWrapper>
    </Fragment>
  );
}

export default appWithTranslation(MyApp, nextI18NextConfig);
